<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);
const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { agents_see_assigned_or_unassigned_conversations } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!agents_see_assigned_or_unassigned_conversations;
  },
  { deep: true, immediate: true }
);

const toggleVisibility = async () => {
  try {
    await updateAccount({
      agents_see_assigned_or_unassigned_conversations: isEnabled.value,
    });
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.SUCCESS')
    );
  } catch (error) {
    isEnabled.value = !isEnabled.value;
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggleVisibility" />
      </div>
    </template>
  </SectionLayout>
</template>
